<script>
  import Dropdown from '@components/general/dropdown.svelte'
  import { router } from '@inertiajs/svelte'
  import { Eye, EyeOff, Unlock, Lock, Trash2, Wand } from 'lucide-svelte'

  let { selection, path } = $props()

  function batchChangeStatus(status) {
    if (!path) return
    if (!window.confirm(`Are you sure you want to make all selected items ${status}?`)) return
    router.post(`/admin/${path}/batch_status`, { status, ids: selection.ids }, {
      onSuccess: selection.clear()
    })
  }

  function batchChangeAccess(access) {
    if (!path) return
    if (!window.confirm(`Are you sure you want to make all selected items ${access}?`)) return
    router.post(`/admin/${path}/batch_access`, { access, ids: selection.ids }, {
      onSuccess: selection.clear()
    })
  }

  function batchDelete() {
    if (!path) return
    if (!window.confirm(`Delete the selected items from the platform?`)) return
    router.visit(`/admin/${path}/batch_delete`, { method: "delete", data: { ids: selection.ids } }, { onSuccess: selection.clear() })
  }
</script>

<!-- Actions -->
{#if selection?.populated}
  <Dropdown buttonProps={{ text: `${selection.count} selected`, size: "md", Icon: Wand }} width="16rem" align="start" itemSize="sm">
    {#snippet contents(item)}
      {@render item({ text: "Mark active", icon: Eye, onSelect: () => batchChangeStatus("active") })}
      {@render item({ text: "Mark hidden", icon: EyeOff, onSelect: () => batchChangeStatus("inactive") })}
      {@render item({ text: "Make available to all", icon: Unlock, onSelect: () => batchChangeAccess("free") })}
      {@render item({ text: "Make premium only", icon: Lock, onSelect: () => batchChangeAccess("premium") })}
      {@render item({ text: "Delete from platform", icon: Trash2, onSelect: () => batchDelete() })}
    {/snippet}
  </Dropdown>
{/if}